import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PRECO_DIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PRECO_DIA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'PRECO_DIA_FILTRO',
        payload: filtro
    };
}

export function initForm(registro = {}) {
    return [
        initialize('precoDiaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/precoDia?data=${DateFormat.formatarDataTelaParaSql(getState().precoDia.filtro.data)}`)
		.then(resp => {
			dispatch({
		        type: 'PRECO_DIA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/precoDia`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {

				await axios.post(`${consts.API_URL}/politicaPreco/reprocessar`)
				.then(async resp => {
					console.log('Política atualizada');
				}).catch(e => {
					setErroAPI(e);
				});				
				dispatch(setAguardando(false));

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/precoDia`, {
				...registro,
				preco: FormatUtils.formatarValorBanco(registro.preco, 4),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {

				await axios.post(`${consts.API_URL}/politicaPreco/reprocessar`)
				.then(async resp => {
					console.log('Política atualizada');
				}).catch(e => {
					setErroAPI(e);
				});	
				dispatch(setAguardando(false));

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/precoDia?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'PRECO_DIA_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaDistribuidora() {
    const request = axios.get(`${consts.API_URL}/distribuidora/listarSelect`);
    return {
        type: 'PRECO_DIA_DISTRIBUIDORA_SELECT_LISTADO',
        payload: request
    };
}